<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity">
    </activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <bank-statement-manual-upload-item
      ref="bankStatementUploadItem"
      class="margin_top_20"
      :show="showUploadFragment"
      :upload-only-front-page="true"
      :allow-only-p-d-f="false"
      instruction="Please upload Bank Statement PDF or Front Page image."
      @onBankStatementsUploaded="getNextTask"
    ></bank-statement-manual-upload-item>

    <div v-if="!showUploadFragment" class="margin_top_20">
      <div v-if="showUI">
        <weex-text class="item-sm-heading margin-left-10 margin-right-10">{{message}}</weex-text>

        <div v-if="impsVisibility">

          <div class="margin_top_20 margin-left-10 margin-right-10">
            <weex-text class="font-size-sm-base">{{impsStatusText}}</weex-text>
            <weex-text class="margin-top-10 font-size-sm-base">{{bankProvidedName}}</weex-text>
            <weex-text class="margin-top-10 font-size-sm-base">{{customerProvidedName}}</weex-text>
          </div>


          <div v-if="!bankVerificationResponse.nameMatch" class="margin-top-10">
            <wxc-radio
              :list="useNameList"
              :config="radioButtonConfig"
              :radio-button-on-right="false"
              :has-bottom-border="false"
              @wxcRadioListChecked="onNameOptionSelected">
            </wxc-radio>
            <div class="input_container" v-if="provideNewNameSelected">
              <weex-text class="input_label">Customer Name</weex-text>
              <input
                class="input_with_border_bottom"
                :value="customerName"
                @input="customerName=$event.target.value">
            </div>
          </div>
        </div>
        <div v-if="showBankDetailsUploadButtons">
          <wxc-button
            v-if="!bankVerificationResponse.changeBankDetails"
            text="Upload Documents"
            class="button_horizontal_center margin_top_40"
            type="blue"
            @wxcButtonClicked="uploadSupportingDocumentsClicked"
          ></wxc-button>

          <wxc-button
            text="Update Bank Details"
            class="button_horizontal_center margin_top_40"
            type="blue"
            @wxcButtonClicked="updateBankDetailsClicked"
          ></wxc-button>
        </div>

        <wxc-button
          v-if="showNextButton || showSkipButton"
          :text="nextButtonText"
          class="button_horizontal_center margin_top_40"
          size="full"
          type="blue"
          @wxcButtonClicked="onSubmit"
        ></wxc-button>
      </div>
    </div>
  </div>
</template>

<script>
import ToolBar from "../../layout/ToolBar";
import loanTaskUtility from "@/utils/LoanTasksUtility"
import loanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
import { Activities } from "@/utils/ActivityNavigator"
import loanTaskActivityNavigator from "@/utils/LoanTasksActivityNavigator";
import BankStatementManualUploadItem from "../../layout/BankStatementManualUploadItem";
import Loading from "../../layout/Loading";
import dataSource from "../../../data/DataSource";
import ErrorAlertItem from "@/components/layout/ErrorAlertItem";
import alertService from "@/components/core/alert/AlertService";
import EzUtils from "../../../utils/EzUtils";
import { DataTables } from "../../../utils/DataTables";
import WxcRadio from "@/../weex-ui/packages/wxc-radio/index"
import WxcButton from "@/../weex-ui/packages/wxc-button/index"
import { DefaultResourceConfig } from "@/utils/ImageResourcesUtil";
import { MessageConstants } from "@/utils/MessageConstantUtil";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import StageCommentItem from "../../layout/StageCommentItem";
import storageUtil from "../../../utils/StorageUtil";
import AttributeUtil, { AttributeDetails } from '../../../utils/AttributeUtil';
import DataSource from '../../../data/DataSource';
import { EntityType } from '../../../utils/EntityType';

export default {
  name: "BankDetailsVerificationActivity",
  components: {
    ActivityRedirectItem,
    ToolBar,
    WxcRadio,
    WxcButton,
    BankStatementManualUploadItem,
    Loading,
    ErrorAlertItem,
    StageCommentItem
  },
  data: () => ({
    toolbarTitle: "Bank Details Verification",
    customerName: "",
    loanId: loanScopeDataHolder.getLoanId(),
    message: "",
    useNameList: [
      { "title": "Same as Bank provided name", "value": "SAME_AS_BANK_PROVIDED" },
      { "title": "Same as Customer provided name", "value": "SAME_AS_CUSTOMER_PROVIDED" },
      { "title": "Provide new name", "value": "PROVIDE_NEW_NAME" }
    ],
    bankVerificationResponse: {},
    changeBankDetails: false,
    bankProvidedName: "",
    customerProvidedName: "",
    impsStatusText: "",
    impsVisibility: true,
    showBankDetailsUploadButtons: true,
    showNextButton: false,
    selectedNameOption: "",
    provideNewNameSelected: false,
    showUploadFragment: false,
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showUI: false,
    showSkipButton : false
  }),
  methods: {
    onNameOptionSelected(e) {
      this.selectedNameOption = e.value;
      this.provideNewNameSelected = (this.selectedNameOption === "PROVIDE_NEW_NAME");
    },

    showError(res) {
      this.loading = false;
      this.networkError = res.data;
      this.errorAlertEvent = true;
    },

    showToast(message) {
      alertService.showToast(message)
    },

    uploadSupportingDocuments() {
      this.saveAttributeInPennyDropFailureCase("upload.document")
      .then(attributeSaved => {
        if(attributeSaved) {
          this.showUploadFragment = true
          this.$refs.bankStatementUploadItem.fetchInitialData();
        }
      });
    },

    updateBankDetailsAndGoNext() {
      this.loading = true;
      loanTaskUtility.getTasks(loanScopeDataHolder.getLoanId(), false, null)
        .then(res => {
          if (res.errorOccurred) {
            this.showError(res);
          } else {
            let bankDetailsTask = this.getBankDetailsLoanTask(res.data.agentTasks);
            loanTaskUtility.updateLoanTask(bankDetailsTask, "PENDING")
              .then(res => {
                if (res.errorOccurred) {
                  this.showError(res);
                } else {
                  console.log(loanScopeDataHolder.getCurrentLoanTask());
                  loanTaskUtility.updateLoanTask(loanScopeDataHolder.getCurrentLoanTask(),
                    "COMPLETED")
                    .then(res => {
                      if (res.errorOccurred) {
                        this.showError(res);
                      } else {
                        this.loading = false;
                        loanScopeDataHolder.setCurrentLoanTask(bankDetailsTask)
                        this.validateAndSaveIfNeeded(false)
                      }
                    })
                }
              })
          }
        })
    },

    updateBankDetailsClicked() {
      if (this.checkForValidation()) {
        this.saveAttributeInPennyDropFailureCase("update.bank.details")
        .then(attributeSaved => {
          if(attributeSaved) {
            this.updateBankDetailsAndGoNext();
          }
        });
      }
    },

    uploadSupportingDocumentsClicked() {
      if (this.bankVerificationResponse.impsStatus) {
        this.validateAndSaveIfNeeded(true)
      } else {
        this.uploadSupportingDocuments();
      }
    },

    getBankDetailsLoanTask(loanTaskList) {
      let bankDetailsTask = null;
      loanTaskList.forEach(it => {
        if ("BANK_DETAILS" === it.name) {
          bankDetailsTask = it
        }
      });
      return bankDetailsTask
    },

    onSubmit() {
      if(this.showSkipButton) {
        this.saveAttributeInPennyDropFailureCase("skip")
         .then(attributeSaved => {
          if(attributeSaved) {
            this.getNextTask();
          }
        });
      } else {
        this.getNextTask();
      }
    },

    getNextTask() {
      this.loading = true;
      loanTaskActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data)
          }
        });
    },

    saveAttributeInPennyDropFailureCase(pennyDropFailureOptionSelected) {
      return new Promise(resolve => {
          if(pennyDropFailureOptionSelected) {
          this.loading = true;
          DataSource.createOrUpdateAttribute(
            AttributeUtil.getAttributeUpdateDto(
              EntityType.LOANS,
              loanScopeDataHolder.getLoanId(),
              AttributeUtil.getSingleAttributeData(
                AttributeDetails.PENNY_DROP_FAILURE_OPTION_SELECTED.key,
                AttributeDetails.PENNY_DROP_FAILURE_OPTION_SELECTED.name,
                pennyDropFailureOptionSelected
              )
            )
          )
          .then(res => {
            this.loading = false;
            if (res.errorOccurred) {
              this.showError(res.data);
              resolve(false);
            } else {
              resolve(true);
            }
          })
        }
      })
    },

    checkForValidation() {
      if (!this.bankVerificationResponse.nameMatch
        && this.impsVisibility
        && EzUtils.isEmpty(this.selectedNameOption)
      ) {
        this.showToast(MessageConstants.NAME_OPTION_NOT_SELECTED_MESSAGE);
        return false;
      }
      if (this.provideNewNameSelected && EzUtils.isEmpty(this.customerName)) {
        this.showToast(MessageConstants.EMPTY_CUSTOMER_NAME_MESSAGE);
        return false;
      }
      return true
    },

    validateAndSaveIfNeeded(forUploadDocuments) {
      if (this.bankVerificationResponse.nameMatch) {
        this.goToNextActivity(forUploadDocuments)
      } else {
        if (this.checkForValidation()) {
          this.loading = true;
          let data = {};
          data["account_holder_name"] = (this.provideNewNameSelected) ? this.customerName
            : this.bankVerificationResponse.bankProvidedName;
          dataSource.getDataTableInfo(DataTables.BANK_DETAILS, loanScopeDataHolder.getClientId())
            .then(resData => {
              if (resData.errorOccurred) {
                this.showError(resData);
              } else {
                if (!EzUtils.isEmpty(resData.data)) {
                  let bankDetails = resData.data[resData.data.length - 1];
                  dataSource.updateDataTableEntryInMultiRowDataTable(DataTables.BANK_DETAILS,
                    loanScopeDataHolder.getClientId(),
                    bankDetails.id, data
                  ).then(resData => {
                    this.loading = false;
                    if (resData.errorOccurred) {
                      this.showError(resData);
                    } else {
                      this.goToNextActivity(forUploadDocuments)
                    }
                  })
                } else {
                  this.loading = false;
                }
              }
            })
        }
      }
    },

    goToNextActivity(forUploadDocuments) {
      if (forUploadDocuments) {
        this.uploadSupportingDocuments();
      } else {
        loanTaskActivityNavigator.nextActivity(Activities.BANK_DETAILS);
      }
    }
  },

  created: function () {
    this.loading = true;
    dataSource.getLoanStageConfigData(
      loanScopeDataHolder.getLoanId(),
      "BANK_DETAILS_VERIFICATION"
    )
      .then(resData => {
        this.loading = false;
        if (resData.errorOccurred) {
          this.showError(resData);
        } else {
          this.showUI = true;
          let res = resData.data;
          this.message = res.message;
          this.bankVerificationResponse = res;
          if (res.success) {
            this.impsVisibility = false;
            this.showBankDetailsUploadButtons = false;
            this.showNextButton = true;
          } else {
            if (res.impsStatus) {
              this.impsStatusText = "\u2022 Imps status : SUCCESS";
              this.bankProvidedName = "\u2022 Bank provided name : " + res.bankProvidedName;
              this.customerProvidedName = "\u2022 Customer provided name : "
                + res.customerProvidedName;
            } else {
              this.impsVisibility = false;
            }
            this.showSkipButton = res.showSkipButton
          }
        }
      })
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.BANK_DETAILS_VERIFICATION]
    },

    currentTaskName() {
      return loanScopeDataHolder.getCurrentLoanTask()
        ? loanScopeDataHolder.getCurrentLoanTask().name : ""
    },

    radioButtonConfig() {
      return DefaultResourceConfig.RADIO_BUTTON
    },

    nextButtonText() {
      return this.showSkipButton ? "Skip And Move To Next Stage" : "Next";
    }
  }
}
</script>

<style scoped src="../../../assets/style/base.css"></style>
